<template>
  <div style="display: inline-flex; align-items: center">
    <!-- @click="handleConfirmationCall(record)" -->
    <a class="phone" @click="handleConfirmationCall" v-if="userDataInfo">{{ text }}</a>
    <span disabled v-if="!userDataInfo"> {{ text }}</span>
    <a-tooltip v-if="record?.is_whatsapp && whatsappUsername">
      <template #title>
        <div>
          <div>Nombre de usuario en WhatsApp:</div>
          <div>{{ whatsappUsername }}</div>
        </div>
      </template>
      <img
        :src="whatsappIcon"
        alt="WhatsApp"
        width="14"
        height="14"
        style="margin: 0 5px; cursor: pointer"
      />
    </a-tooltip>
    <img
      v-else-if="record?.is_whatsapp"
      :src="whatsappIcon"
      alt="WhatsApp"
      width="14"
      height="14"
      style="margin: 0 5px"
    />
    <HubspotIcon
      v-if="record?.phone_pending_sync_hubspot || record?.phone_synced_hubspot"
      style="margin: 0 5px"
      size="14"
      :color="!record?.phone_pending_sync_hubspot ? undefined : '#8C8C8C'"
    />
    <a-popover v-model:open="moreOptionsOpen" trigger="click">
      <template #content>
        <div class="popover-content">
          <ul>
            <li>
              <a-tooltip placement="left">
                <template #title v-if="validateBlacklist(ChannelType.Sms)">
                  Este Número se encuentra bloqueado para mandar mensaje de SMS
                </template>
                <a-button
                  type="text"
                  class="popover_button"
                  :disabled="!record.country?.code_phone || validateBlacklist(ChannelType.Sms)"
                  @click="
                    emit('click:sms');
                    moreOptionsOpen = false;
                  "
                >
                  <MessageOutlined />
                  Enviar SMS
                  <a-tag
                    v-if="!accessSms"
                    :color="ActionPlanStrategyColor[ActionPlanStrategy.Upgrade]"
                  >
                    {{ ActionPlanStrategyText[ActionPlanStrategy.Upgrade] }}
                  </a-tag>
                </a-button>
              </a-tooltip>
            </li>
            <li>
              <a-tooltip placement="left">
                <template #title v-if="validateBlacklist(ChannelType.Voice)">
                  Este Número se encuentra bloqueado para realizar llamadas saliente
                </template>
                <a-button
                  type="text"
                  class="popover_button"
                  @click="
                    emit('click:phone');
                    moreOptionsOpen = false;
                  "
                  :disabled="validateBlacklist(ChannelType.Voice)"
                >
                  <PhoneOutlined style="transform: scaleX(-1)" />
                  Llamar
                  <a-tag
                    v-if="!accessVoice"
                    :color="ActionPlanStrategyColor[ActionPlanStrategy.Upgrade]"
                  >
                    {{ ActionPlanStrategyText[ActionPlanStrategy.Upgrade] }}
                  </a-tag>
                </a-button>
              </a-tooltip>
            </li>
            <li v-if="getUserData?.allow_send_template">
              <!-- <a-tooltip placement="left">
                <template #title v-if="validateBlacklist(ChannelType.Whatsapp)">
                  Este Número se encuentra bloqueado para mandar mensajes de Whatsapp
                </template> -->
              <SendWhatsappTemplateModalVue
                :popover-button="true"
                :record="{ ...record, ...contact }"
                :disabled="!record.country?.code_phone || validateBlacklist(ChannelType.Whatsapp)"
                :validate-blacklist="validateBlacklist(ChannelType.Whatsapp)"
              />
              <!-- </a-tooltip> -->
            </li>
          </ul>
        </div>
      </template>
      <a-button style="padding: 0; height: 22px" type="link">
        <EllipsisOutlined :rotate="90" />
      </a-button>
    </a-popover>
  </div>
</template>

<script setup>
import { EllipsisOutlined, MessageOutlined, PhoneOutlined } from "@ant-design/icons-vue";
import { computed, ref } from "vue";

import SendWhatsappTemplateModalVue from "@/app/workspace/components/modal/SendWhatsappTemplateModal.vue";
import { ChannelType } from "@/app/shared/utils/enums";
import { ActionPlanStrategy, ActionPlanStrategyColor, ActionPlanStrategyText } from "@/app/common/utils/enums";
import HubspotIcon from "@/app/integrations/components/icons/HubspotIcon.vue";
import whatsappIcon from "@/app/shared/assets/channels/whatsapp.svg?url";

const props = defineProps({
  record: { type: Object, default: () => ({}) },
  contact: { type: Object, default: () => ({}) },
  getUserData: { type: Object, default: () => ({}) },
  userDataInfo: { type: Object, default: () => undefined },
  text: { type: String, default: () => undefined },
  portfolio: { type: Object, default: () => ({}) },
  accessVoice: { type: Boolean, default: false },
  accessSms: { type: Boolean, default: false },
});

const emit = defineEmits(["click:phone", "click:sms", "handleConfirmationCall"]);

const moreOptionsOpen = ref(false);

const whatsappUsername = computed(() => {
  const raw =
    props.record?.whatsapp_username ||
    props.contact?.whatsapp_username ||
    props.record?.whatsappUsername ||
    "";
  if (!raw) return "";
  const trimmed = String(raw).trim();
  return trimmed.startsWith("@") ? trimmed : `@${trimmed}`;
});

const handleConfirmationCall = () => {
  emit("handleConfirmationCall");
};
const validateBlacklist = (channel) => {
  const index = props.record.blacklist?.findIndex((el) => {
    if (el.channel?.id === channel) {
      if (channel === ChannelType.Voice) {
        return el.portfolios?.some((portfolio) => portfolio.id === props.portfolio.id);
      }
      return true;
    }
    return false;
  });
  return index > -1;
};
</script>

<style scoped lang="sass">
.popover-content
  ul
    list-style: none
    padding-left: 0
    margin: 0

    li
      button
        width: 100%
        text-align: left
        padding: 0 5px
        display: flex
        align-items: center
        gap: 5px

        &:hover
          background: #0000000A
        .icon
          height: 13px

.popover_button
  display: flex
  align-items: center
</style>
